import { render } from "./NavItemComponent.vue?vue&type=template&id=c4808248"
import script from "./NavItemComponent.vue?vue&type=script&lang=js"
export * from "./NavItemComponent.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./NavItemComponent.vue?vue&type=style&index=0&id=c4808248&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__